import { serviceApi } from 'Shared/network';
import type { GetViewupPlusSnsAccountsByUserUuidOkDto } from 'viewup-api';

export type GetViewupPlusSnsAccountsRes = GetViewupPlusSnsAccountsByUserUuidOkDto;

export const getViewupPlusSnsAccounts = async (): Promise<GetViewupPlusSnsAccountsRes> => {
  const response =
    await serviceApi.v1SnsAccount.snsAccountControllerGetViewupPlusSnsAccountsByUserUuid();

  return response.data;
};
